const IN_PERSON = 'in_person';
const PHONE_CALL = 'phone_call';

export const MEETING_KIND_OPTIONS = [
  {
    id: IN_PERSON,
    value: IN_PERSON,
    name: 'Un rendez-vous à l\'agence',
  },
  {
    id: PHONE_CALL,
    value: PHONE_CALL,
    name: 'Un rendez-vous téléphonique',
  },
];

export const MEETING_KIND_ACTION = {
  [IN_PERSON]: 'venue',
  [PHONE_CALL]: 'appel',
};

export const meetingKindAction = (kind) => MEETING_KIND_ACTION[kind] || 'venue';

export const MEETING_DEFAULT_KIND = IN_PERSON;
